import { useState } from "react";
import { saveReportingWbsDetails } from "../Api/ReportingWbs";
import {
  Accordion,
  AccordionItem,
  AccordionBody,
  Form,
  Button,
  Row,
  Col,
} from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";

const ReportingWbsReport = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [wbsData, setWbsData] = useState({
    wbsCode: "",
    operationalReportHead: "",
    orgPerformance: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setWbsData({
      ...wbsData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveReportingWbsDetails(wbsData, userId);
      toast.success(`🦄 Reporting WBS Added Successfully`);
      setWbsData({
        wbsCode: "",
        operationalReportHead: "",
        orgPerformance: "",
      });
    } catch (error) {
      toast.error(
        `🦄 Error: ${error.message || "Failed to save reporting WBS details"}`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container gl-master-fields">
        <h2 className="fields-title">Reporting WBS Report</h2>

        <Form onSubmit={handleSubmit} className="fields-form">
          <Accordion defaultActiveKey="0" className="gl-master-accordion">
            <AccordionItem eventKey="0">
              <AccordionBody>
                <Row>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Reporting WBS Code <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="wbsCode"
                        value={wbsData.wbsCode}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Operational Report Head{" "}
                        <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="operationalReportHead"
                        value={wbsData.operationalReportHead}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Org Performance <span className="text-red">**</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="orgPerformance"
                        value={wbsData.orgPerformance}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
          <div className="fields-btn-container" style={{ marginTop: 16 }}>
            <Button variant="primary" type="submit" className="fields-submit">
              Save Reporting WBS
            </Button>
          </div>
        </Form>
      </div>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default ReportingWbsReport;
